import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonPrimaryComponent } from 'projects/components/button-primary/button-primary.component';
import { environment } from 'projects/login/src/environments/environment';
import { RedirectService } from '../../../services/redirect/redirect.service';

@Component({
  selector: 'pay-login-act-finished',
  imports: [TranslateModule, ButtonPrimaryComponent],
  templateUrl: './act-finished.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActFinishedComponent {
  private readonly _redirectService = inject(RedirectService);

  redirectDashboard() {
    this._redirectService.goRedirectUrl(environment.activation.returnUrl);
  }
}
